import angular from "angular";

angular
    .module('app')
    .component('clientEmployeesControl', {
        template: require('./client-employees-control.html'),
        controller: ['$http', '$uibModal', 'notifier', controller],
        bindings: {
            client: '<',
            selectedFields: '<',
        }
    });

function controller($http, $uibModal, notifier) {

    const $ctrl = this;

    $ctrl.employees = [];

    $ctrl.total = null;

    $ctrl.page = 1;

    $ctrl.perPage = 15;

    $ctrl.search = '';

    $ctrl.$onInit = () => {
        $ctrl.getList();
        $ctrl.setTableFields();
    };

    $ctrl.setTableFields = () => {
        $ctrl.tableFields = $ctrl.selectedFields.filter(v => !! v.pivot.edit_on_directory);
    };

    $ctrl.getList = () => {
        $http
            .get(`/clients/${$ctrl.client.id}/employees/get-list`, {
                params: {
                    page: $ctrl.page,
                    search: $ctrl.search,
                }
            })
            .then(res => {
                $ctrl.total = res.data.total;
                $ctrl.employees = res.data.data;

                $ctrl.employees.forEach(emp => {
                    emp.fieldValues = {};

                    $ctrl.selectedFields.forEach(field => {
                        const fieldValue = emp.field_values.find(v => v.field_id === field.id);

                        if (fieldValue) {
                            emp.fieldValues[field.id] = fieldValue.value;
                        }

                        if (field.pivot.default_value && !emp.fieldValues[field.id]) {
                            emp.fieldValues[field.id] = field.pivot.default_value;
                        }
                    });
                });
            });
    };


    $ctrl.filter = () => {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.openForm = (employee) => {
        $uibModal.open({
            component: 'employeeForm',
            resolve: {
                mode() {
                    return 'from-clients';
                },
                client() {
                    return $ctrl.client;
                },
                fields() {
                    return $ctrl.selectedFields;
                },
                employee() {
                    return employee;
                }
            },
            size: 'lg',
        }).result.then(res => {
            $ctrl.getList();
        });
    };

    $ctrl.delEmployee = (employee, ind) => {
        if (confirm('Вы действительно хотите удалить данного сотрудника?')) {
            $http
                .post(`/clients/${$ctrl.client.id}/employees/${employee.id}`, {
                    _method: 'DELETE'
                })
                .then(res => {
                    $ctrl.employees.splice(ind, 1);
                    notifier.successNotify('Успешно удален');
                })
                .catch(err => {
                    notifier.errorResponseNotify(err);
                })
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/client-employees-control/client-employees-control.js